module.exports = __webpack_public_path__ + "img/img_product1.568bf922.png";